import { defineComponent as x, inject as D, computed as i, markRaw as v, provide as S, h as C } from "vue";
import { configProviderInjectionKey as g } from "./ghl-ui.es949.js";
import B from "./ghl-ui.es950.js";
import h from "./ghl-ui.es706.js";
import { defaultClsPrefix as s } from "./ghl-ui.es854.js";
import b from "./ghl-ui.es951.js";
import { warn as k } from "./ghl-ui.es853.js";
const N = {
  abstract: Boolean,
  bordered: {
    type: Boolean,
    default: void 0
  },
  clsPrefix: {
    type: String,
    default: s
  },
  locale: Object,
  dateLocale: Object,
  namespace: String,
  rtl: Array,
  tag: {
    type: String,
    default: "div"
  },
  hljs: Object,
  katex: Object,
  theme: Object,
  themeOverrides: Object,
  componentOptions: Object,
  icons: Object,
  breakpoints: Object,
  preflightStyleDisabled: Boolean,
  inlineThemeDisabled: {
    type: Boolean,
    default: void 0
  },
  // deprecated
  as: {
    type: String,
    validator: () => (k("config-provider", "`as` is deprecated, please use `tag` instead."), !0),
    default: void 0
  }
}, E = x({
  name: "ConfigProvider",
  alias: ["App"],
  props: N,
  setup(r) {
    const e = D(g, null), a = i(() => {
      const {
        theme: n
      } = r;
      if (n === null)
        return;
      const d = e == null ? void 0 : e.mergedThemeRef.value;
      return n === void 0 ? d : d === void 0 ? n : Object.assign({}, d, n);
    }), t = i(() => {
      const {
        themeOverrides: n
      } = r;
      if (n !== null) {
        if (n === void 0)
          return e == null ? void 0 : e.mergedThemeOverridesRef.value;
        {
          const d = e == null ? void 0 : e.mergedThemeOverridesRef.value;
          return d === void 0 ? n : B({}, d, n);
        }
      }
    }), f = h(() => {
      const {
        namespace: n
      } = r;
      return n === void 0 ? e == null ? void 0 : e.mergedNamespaceRef.value : n;
    }), m = h(() => {
      const {
        bordered: n
      } = r;
      return n === void 0 ? e == null ? void 0 : e.mergedBorderedRef.value : n;
    }), R = i(() => {
      const {
        icons: n
      } = r;
      return n === void 0 ? e == null ? void 0 : e.mergedIconsRef.value : n;
    }), O = i(() => {
      const {
        componentOptions: n
      } = r;
      return n !== void 0 ? n : e == null ? void 0 : e.mergedComponentPropsRef.value;
    }), c = i(() => {
      const {
        clsPrefix: n
      } = r;
      return n !== void 0 ? n : e ? e.mergedClsPrefixRef.value : s;
    }), p = i(() => {
      var n;
      const {
        rtl: d
      } = r;
      if (d === void 0)
        return e == null ? void 0 : e.mergedRtlRef.value;
      const l = {};
      for (const o of d)
        l[o.name] = v(o), (n = o.peers) === null || n === void 0 || n.forEach((u) => {
          u.name in l || (l[u.name] = v(u));
        });
      return l;
    }), j = i(() => r.breakpoints || (e == null ? void 0 : e.mergedBreakpointsRef.value)), T = r.inlineThemeDisabled || (e == null ? void 0 : e.inlineThemeDisabled), y = r.preflightStyleDisabled || (e == null ? void 0 : e.preflightStyleDisabled), P = i(() => {
      const {
        value: n
      } = a, {
        value: d
      } = t, l = d && Object.keys(d).length !== 0, o = n == null ? void 0 : n.name;
      return o ? l ? `${o}-${b(JSON.stringify(t.value))}` : o : l ? b(JSON.stringify(t.value)) : "";
    });
    return S(g, {
      mergedThemeHashRef: P,
      mergedBreakpointsRef: j,
      mergedRtlRef: p,
      mergedIconsRef: R,
      mergedComponentPropsRef: O,
      mergedBorderedRef: m,
      mergedNamespaceRef: f,
      mergedClsPrefixRef: c,
      mergedLocaleRef: i(() => {
        const {
          locale: n
        } = r;
        if (n !== null)
          return n === void 0 ? e == null ? void 0 : e.mergedLocaleRef.value : n;
      }),
      mergedDateLocaleRef: i(() => {
        const {
          dateLocale: n
        } = r;
        if (n !== null)
          return n === void 0 ? e == null ? void 0 : e.mergedDateLocaleRef.value : n;
      }),
      mergedHljsRef: i(() => {
        const {
          hljs: n
        } = r;
        return n === void 0 ? e == null ? void 0 : e.mergedHljsRef.value : n;
      }),
      mergedKatexRef: i(() => {
        const {
          katex: n
        } = r;
        return n === void 0 ? e == null ? void 0 : e.mergedKatexRef.value : n;
      }),
      mergedThemeRef: a,
      mergedThemeOverridesRef: t,
      inlineThemeDisabled: T || !1,
      preflightStyleDisabled: y || !1
    }), {
      mergedClsPrefix: c,
      mergedBordered: m,
      mergedNamespace: f,
      mergedTheme: a,
      mergedThemeOverrides: t
    };
  },
  render() {
    var r, e, a, t;
    return this.abstract ? (t = (a = this.$slots).default) === null || t === void 0 ? void 0 : t.call(a) : C(this.as || this.tag, {
      class: `${this.mergedClsPrefix || s}-config-provider`
    }, (e = (r = this.$slots).default) === null || e === void 0 ? void 0 : e.call(r));
  }
});
export {
  N as configProviderProps,
  E as default
};
